import React from 'react';
import { useLocation } from 'react-router';

export interface ReturnToState {
  returnTo: string;
}

export function useReturnToState(): ReturnToState {
  const location = useLocation();
  return React.useMemo(
    () => ({ returnTo: `${location.pathname}${location.search}` }),
    [location.pathname, location.search],
  );
}

export function useReturnTo(fallback: string): string {
  const location = useLocation();
  const state = location.state as Partial<ReturnToState> | null;
  return state?.returnTo ?? fallback;
}
